<a class="ft-btn-backtotop"
   ftScrollTo=".ft-scroll-anchor">
    <i class="ft-icn-arrow-up"></i>
</a>

<ui-view />

<ft-create-property />
<ft-create-account />
<ft-spaces />
